/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : EvaluatedActionExecutor.ts
*******************************************/

import { TypeGuard } from "@ciaopeople/cp-shatsu/CustomTypes";
import { SpecificEvaluatedAction } from "../EvaluatedAction.js";

export enum EvaluationName {
    MAYBE_INTERACTIVE_AUTOLOGIN_EVALUATION = "MaybeInteractiveAutoLoginEvaluation",
    LOGIN_EVALUATION = "LoginEvaluation",
    APP_DOWNLOAD_EVALUATION = "AppDownloadEvaluation",
    PERSONAL_DATA_EVALUATION = "PersonalDataEvaluation",
    SUBSCRIPTION_EVALUATION = "SubscriptionEvaluation"
}

export enum CTAExecutionResult {
    /**
     * CTA Realizzata
     */
    COMPLETED = 0,
    /**
     * Errore 
     */
    ERROR = 1,
    /**
     * Nessuna CTA da eseguire
     */
    NOT_EXECUTED = 2,
    /**
     * CTA Chiusa esplicitamente dall'utente
     * Questo caso tecnicamente
     */
    DISMISSED = 3
}

export type DISMISSED_CTA = {
    __CTA_DISMISSED: 1
};
export const DISMISSED_CTA = {
    __CTA_DISMISSED: 1
};

export function isDismissedCTA(x: any): x is DISMISSED_CTA {
    return x == DISMISSED_CTA;
}

export interface EvaluatedActionExecutor {
    isExpectedType: (TypeGuard<SpecificEvaluatedAction>) | ( (act: SpecificEvaluatedAction) => boolean ),
    execute: (evaluator: NamedCtaEvaluator, act: SpecificEvaluatedAction, data?: any) => Promise<CTAExecutionResult>
}

export interface EvaluatedActionQueueElement {
    action: SpecificEvaluatedAction,
    data: Record<string, any>
}

export type EvaluatedActionQueue = EvaluatedActionQueueElement[];

/**
 * Classe che permette l'esecuzione con coda delle CTA. Permette di aggiungere esecuzioni (via queue) e valutazioni (via evaluate)
 * 
 */
export interface NamedCtaEvaluator {
    /**
     * Esegue una valutazione che se completata con successo inserisce in coda la sua azione
     * La promise restituita dal metodo risolve al completamento della **VALUTAZIONE** (non dell'esecuzione)
     * @param name 
     * @param forced 
     * @param data 
     */
    evaluateNamedCTAQueueUpdate(name: EvaluationName, forced: boolean, data?: Record<string, any>): Promise<SpecificEvaluatedAction|null>;


    enqueueAction(action: SpecificEvaluatedAction, data?: Record<string, any>): void;


    enqueueActionAndAwait(action: SpecificEvaluatedAction, data?: Record<string, any>): Promise<void>;
    
}